import { Box } from '@freighthub/silhouette-core'
import { FC } from 'react'

import { IShipTpEvent } from '../domain/TransportPlanEvent'
import { TpTimestampRangeCtx, TTpTimestampRangeCtx } from '../service/TpTimestampRangeContext'
import { EventDelay } from './TpDelay'
import { TimestampReasonFurthestLatest } from './TpReason'

type TTpRangeDifferentMonthsCtx = {
  showDelay: boolean
  showEllipsis: boolean
  useSingleLine: boolean
  showReason: boolean
}
type TTpRangeDifferentMonthsProps = {
  range: [string, string]
  furthestEvent?: IShipTpEvent
  latestEvent?: IShipTpEvent
}
// 31. Jan 2018 (-3d)
//         -
// 04. Feb 2018 (+1d)
export const LeanTpRangeDifferentMonths: FC<TTpRangeDifferentMonthsProps & TTpRangeDifferentMonthsCtx> = (props) => {
  const { range, furthestEvent, latestEvent, showDelay, showEllipsis, useSingleLine, showReason } = props
  return (
    <div>
      {useSingleLine ? (
        <TpRangeDifferentMonthsSingleLine
          range={range}
          furthestEvent={furthestEvent}
          latestEvent={latestEvent}
          showDelay={showDelay}
          showEllipsis={showEllipsis}
        />
      ) : (
        <TpRangeDifferentMonthsMultiLine
          range={range}
          furthestEvent={furthestEvent}
          latestEvent={latestEvent}
          showDelay={showDelay}
          showEllipsis={showEllipsis}
        />
      )}
      {showReason && (
        <TimestampReasonFurthestLatest
          // @ts-expect-error TS(2322) FIXME: Type 'ITimestampJSON | undefined' is not assignabl... Remove this comment to see the full error message
          furthestTimestamp={furthestEvent && furthestEvent.aggregatedTimestamp}
          // @ts-expect-error TS(2322) FIXME: Type 'ITimestampJSON | undefined' is not assignabl... Remove this comment to see the full error message
          latestTimestamp={latestEvent && latestEvent.aggregatedTimestamp}
        />
      )}
    </div>
  )
}

const mapCtxToProps = (ctx: TTpTimestampRangeCtx): Required<TTpRangeDifferentMonthsCtx> => ({
  showDelay: ctx.showDelay,
  useSingleLine: ctx.useSingleLine,
  showEllipsis: ctx.showEllipsis,
  showReason: ctx.showReason,
})

const TpRangeDifferentMonthsConsumer: FC<TTpRangeDifferentMonthsProps & Partial<TTpRangeDifferentMonthsCtx>> = (
  props
) => (
  <TpTimestampRangeCtx.Consumer>
    {(ctx) => <LeanTpRangeDifferentMonths {...mapCtxToProps(ctx)} {...props} />}
  </TpTimestampRangeCtx.Consumer>
)

export const TpRangeDifferentMonths = TpRangeDifferentMonthsConsumer

type TTpRangeDifferentMonthsSingleLineProps = {
  range: [string, string]
  furthestEvent?: IShipTpEvent
  latestEvent?: IShipTpEvent
  showDelay: boolean
  showEllipsis: boolean
}
export const TpRangeDifferentMonthsSingleLine: FC<TTpRangeDifferentMonthsSingleLineProps> = (props) => {
  const { range, furthestEvent, latestEvent, showDelay, showEllipsis } = props
  return (
    <Box whiteSpace="nowrap">
      <span>{range[0]}</span>
      {showDelay && (
        // when using ellipsis - show latest event's delay
        // @ts-expect-error TS(2322) FIXME: Type 'IShipTpEvent | undefined' is not assignable ... Remove this comment to see the full error message
        <EventDelay event={showEllipsis ? latestEvent : furthestEvent} />
      )}
      {showEllipsis ? <span>{' \u2026'}</span> : <span> - {range[1]}</span>}
    </Box>
  )
}

type TTpRangeDifferentMonthsMultiLineProps = {
  range: [string, string]
  furthestEvent?: IShipTpEvent
  latestEvent?: IShipTpEvent
  showDelay: boolean
  showEllipsis: boolean
}
export const TpRangeDifferentMonthsMultiLine: FC<TTpRangeDifferentMonthsMultiLineProps> = (props) => {
  const { range, furthestEvent, latestEvent, showDelay, showEllipsis } = props
  return (
    <>
      <Box whiteSpace="nowrap">
        <span>{range[0]}</span>
        {showDelay && (
          // when using ellipsis - show latest event's delay
          // @ts-expect-error TS(2322) FIXME: Type 'IShipTpEvent | undefined' is not assignable ... Remove this comment to see the full error message
          <EventDelay event={furthestEvent} />
        )}
        {showEllipsis ? <span>{' \u2026'}</span> : <span> - {range[1]}</span>}
      </Box>
      {!showEllipsis && (
        <>
          <Box textAlign="center"> - </Box>
          <Box whiteSpace="nowrap">
            <span>{range[1]}</span>
            {/* @ts-expect-error TS(2322) FIXME: Type 'IShipTpEvent | undefined' is not assignable ... Remove this comment to see the full error message */}
            {showDelay && <EventDelay event={latestEvent} />}
          </Box>
        </>
      )}
    </>
  )
}
